<template>
  <section
    id="workstyle"
    class="co-bg-striped"
  >
    <div class="co-container-lg px-4 py-20">
      <h2 class="co-heading-2-caption">
        働き方と収入のイメージ
      </h2>
      <h3 class="co-display-12 mb-[3.25rem] text-center leading-base text-co-gray-600">
        あなたの生活に合わせた働き方をお選びいただけます
      </h3>
      <div class="mb-[3.25rem] flex flex-wrap justify-center lg:justify-start">
        <div class="flex basis-full pr-0 md:basis-1/2 md:pr-4">
          <div class="mb-7 md:mb-0">
            <h4 class="co-display-10 mb-1 text-center">
              土日や夜の空き時間に副業として
            </h4>
            <div class="co-display-12 mb-5 block text-center">
              本業の傍らメンター業務をしているAさん
            </div>
            <div class="mb-3 bg-co-gray-50 p-7 shadow-[0_0_4px_rgba(51,51,51,0.2)]">
              <img
                class="w-full"
                src="~/assets/images/Te/TeJob/WorkStyle/mentor-entry-graph-s-a.png"
                loading="lazy"
                alt="本業の傍らメンター業務をしているAさん"
              >
            </div>
          </div>
        </div>
        <div class="flex basis-full pl-0 md:basis-1/2 md:pl-4">
          <div>
            <h4 class="co-display-10 mb-1 text-center">
              がっつり働いて安定した収入を
            </h4>
            <div class="co-display-12 mb-5 block text-center">
              メインの仕事としてメンター業務をしているBさん
            </div>
            <div class="mb-3 bg-co-gray-50 p-7 shadow-[0_0_4px_rgba(51,51,51,0.2)]">
              <img
                class="w-full"
                src="~/assets/images/Te/TeJob/WorkStyle/mentor-entry-graph-b.png"
                loading="lazy"
                alt="メンター業務をメインでされてるBさん"
              >
            </div>
          </div>
        </div>
      </div>
      <div class="mx-0 flex flex-wrap justify-center">
        <div class="mb-8 basis-full md:basis-8/12">
          <div class="rounded bg-co-gray-50 shadow-[0_0_4px_rgba(51,51,51,0.2)]">
            <div class="co-display-8 w-full rounded-t bg-co-primary-500 p-3 text-center text-co-gray-50">
              定期的に報酬アップの
              <div class="block md:inline">
                機会があります
              </div>
            </div>
            <div class="mx-0 flex flex-wrap items-center">
              <div class="basis-full text-center md:basis-1/2">
                <img
                  class="xs:w-3/4 mx-auto sm:w-2/4 md:w-3/4"
                  src="~/assets/images/Te/TeJob/WorkStyle/salary-up-graph.jpg"
                  loading="lazy"
                  alt="メンター業務をメインでされてるBさん"
                >
              </div>
              <div class="basis-full md:basis-1/2">
                <p class="mx-4 mb-4 mt-0">
                  3ヶ月ごとに時給の見直しを行います。
                  <br class="hidden md:block">
                  稼働の実績と受講生からの評価をベースに
                  <br class="hidden md:block">
                  決定しています。
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="basis-full md:basis-8/12">
          <div class="rounded bg-co-gray-50 shadow-[0_0_4px_rgba(51,51,51,0.2)]">
            <div class="co-display-8 w-full rounded-t bg-co-primary-500 p-3 text-center text-co-gray-50">
              各種サポート制度も
              <div class="block md:inline">
                ご用意しております
              </div>
            </div>
            <div class="mx-0 flex flex-wrap px-4 py-0 pt-4 md:px-3 md:pt-5">
              <div class="mb-4 basis-full text-center md:basis-1/3 md:px-2">
                <h5 class="co-display-9 font-bold text-co-primary-500">
                  傷害保険
                </h5>
                <img
                  class="mx-auto sm:w-1/4 md:w-4/5"
                  src="~/assets/images/Te/TeJob/WorkStyle/img_insurance.svg"
                  loading="lazy"
                  alt="傷害保険"
                >
                <p class="co-display-11 inline">
                  <span class="text-co-primary-500">
                    コロナ入院も対象
                  </span>
                  <br class="inline">
                  日常生活でのケガを
                  <br class="hidden md:block">
                  24時間補償
                </p>
              </div>
              <div class="mb-4 basis-full text-center md:basis-1/3 md:px-2">
                <h5 class="co-display-9 font-bold text-co-primary-500">
                  メディカルアシスト
                </h5>
                <img
                  class="mx-auto sm:w-1/4 md:w-4/5"
                  src="~/assets/images/Te/TeJob/WorkStyle/img_medical-assist.svg"
                  loading="lazy"
                  alt="救急専門医が24時間365日常駐の医療相談デスク"
                >
                <p class="co-display-11 inline">
                  救急専門医が
                  <br class="hidden md:block">
                  24時間365日常駐の
                  <br>
                  医療相談デスク
                </p>
              </div>
              <div class="mb-4 basis-full text-center md:basis-1/3 md:px-2">
                <h5 class="co-display-9 font-bold text-co-primary-500">
                  デイリーサポート
                </h5>
                <img
                  class="mx-auto sm:w-1/4 md:w-4/5"
                  src="~/assets/images/Te/TeJob/WorkStyle/img_daily-support.svg"
                  loading="lazy"
                  alt="デイリーサポート"
                >
                <p class="co-display-11 inline">
                  法律・税務・社会保険に
                  <br>
                  関する専門家への
                  <br class="hidden md:block">
                  相談デスク
                </p>
              </div>
            </div>
            <ul class="co-display-13 mb-0 list-none px-4 pb-4 md:px-5 md:pb-5">
              <li>
                ※月額保険料・費用はTechAcademyが負担し、メンターの皆様の負担はございません。
              </li>
              <li>
                ※3ヶ月間連続稼働した場合に適用されます。
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
